<template>
  <div class="card-back" @click="toAppInfo">
    <div class="card-tag">
      <div v-for="(item,index) in tag" class="tag" :key="index">
        <div class="h5-icon" v-if="item.platform==='webgl'"></div>
        <div class="windows-icon" v-if="item.platform==='windows'"></div>
        <div class="ios-icon" v-if="item.platform==='ios'"></div>
        <div class="android-icon" v-if="item.platform==='android'"></div>
        <div class="vr-icon" v-if="item.platform==='vr'"></div>
      </div>
    </div>
    <div class="card-pic" :class="{'phy-back':subject==='物理','chem-back':subject==='化学','bio-back':subject==='生物'}">
      <div class="skin" v-if="lock">
        <div class="skin-cir">
          <div class="skin-lock"></div>
          <div class="skin-title"></div>
        </div>

      </div>
      <img :src="pic" alt="暂无">
    </div>
    <div class="card-title">
      <div class="title">
        {{title.length>fontCount?title.slice(0,fontCount)+'...':title}}
      </div>
      <div v-if="0" class="title-bottom">

        <div class="more" v-if="0"
             style="font-size:0.7vw;">查看更多</div>
      </div>
    </div>
  </div>
</template>

<script>
const whiteList=['伏安法测电阻','凸透镜成像', '大气压的测量',
  '测量滑轮组的机械效率', '声音波形图',"炼铁的原理",'粉尘爆炸实验','氢气爆炸',
  '分子运动现象（探究）','浓硫酸的稀释','观察洋葱鳞片叶内表皮细胞','探究鱼鳍在游泳中的作用','非生物因素对某种动物的影响','观察眼球的结构',"观察动物细胞和植物细胞"]
// theme.find(i=>i.name===item.platform).color
export default {
  name: 'AppCard',
  data () {
    return {
      fontCount:14,
      lock:true,
      theme: [
        { name: 'webgl', color: '#6fbd6c' },
        { name: 'steamVR', color: '#347fd0' },
        { name: '桌面VR', color: '#feaf3a' },
        { name: 'Windows', color: '#6fbd6c' },
        { name: 'Android', color: '#6fbd6c' },
        { name: 'ios', color: '#6fbd6c' }
      ]
    }
  },

  created() {
    if(sessionStorage.getItem('isSeller')){
      if(sessionStorage.getItem('isSeller')=='true'){
        if(whiteList.find(item=>item==this.title)){
          this.lock=false
        }
        else{
          this.lock=true
        }
      }
      else{
        this.lock=false
      }
    }
    else{
      this.$router.push('/login?way=登录&info=登录信息丢失，请重新登录')
    }
  },
  props: {
    subject: {
      type: String
    },
    id: {
      type: Number,
    },
    title: {
      type: String,
      default: ''
    },
    pic: {
      type: String,
    },
    tag: {
      type: Array
    },
    chapter: {
      type: String
    },
    page:{
      type: Number
    },
    selectRule:{
      type:Array
    },
    searchInput:{
      type:String
    },
    grade: { type: String },
    publisher: { type: String }
  },
  mounted() {
    let width=window.innerWidth/100*11.7
    let fontSize=(window.innerWidth/100*0.7)>12?(window.innerWidth/100*1):12
    this.fontCount=width/fontSize-1
  },
  methods: {
    toAppInfo () {

      if(whiteList.length>0){
        if(!this.lock){
          this.$router.push({
            path: '/appInfo_desktop',
            query: {
              originPath:'/onlineApp_desktop',
              id: this.id,
              subject: this.subject,
              publisher: this.publisher,
              grade: this.grade,
              chapter: this.chapter,
              name: this.title,
              platform: this.tag,
              page:this.page,
              selectRule:this.selectRule,
              search_word:this.searchInput
            }
          })
        }
        else{
          this.$message.error('当前账号无权查看')
        }
      }
      else{
        this.$router.push({
          path: '/appInfo_desktop',
          query: {
            originPath:'/onlineApp_desktop',
            id: this.id,
            subject: this.subject,
            publisher: this.publisher,
            grade: this.grade,
            chapter: this.chapter,
            name: this.title,
            platform: this.tag,
            page:this.page,
            selectRule:this.selectRule,
            search_word:this.searchInput
          }
        })
      }

    }
  }
}
</script>

<style scoped>
.card-back {
  width: 15vw;
  height: 27vh;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
  border-radius: 10px;
  /*background-image: linear-gradient(*/
  /*  0deg,*/
  /*  rgba(92, 108, 122, 1) 0%,*/
  /*  #a1b8ca 100%*/
  /*),*/
  /*linear-gradient(#ffffff, #ffffff);*/
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
}
.card-back:hover {
  cursor: pointer;
  transform: scale(1.05) translateZ(0);
}
.card-back:hover .card-pic{

}
.card-back:hover .title{
  color: #5eb2f7;
}
.card-pic {
  width: 100%;
  height: 22vh;
  border-radius: 10px   10px 0 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}
.skin{
  border-radius: 10px   10px 0 0;
  position: absolute;
  width: 100%;
  height: 22vh;
  background-color: rgba(0,0,0,.25);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.skin-cir{
  position: relative;

  background-image: url("http://data.xiyilab.com/web/main/static//app/圆.png");
  width: 13vw;
  height: 12.2vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.skin-title{
  /*background-image: url("http://data.xiyilab.com/web/main/static//app/当前账号无权查看.png");*/
  min-width: 5.2vw;
  height: 1vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 1vw;
}
.skin-lock{
  position: absolute;
  top:0vw;
  right:-.5vw;
  margin-top: 1.5vw;
  background-image: url("http://data.xiyilab.com/web/main/static//app/锁.png");
  width: 1.5vw;
  height: 1.5vw;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}
.card-pic>img{
  height:80% ;
  width: auto;

}
.card-title {
  height: 5vh;
  min-height: 20px;
  display: flex;
  flex-direction: column;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.title {
  display: inline-block;
  height:5vh;
  line-height: 5vh;
  text-align: center;
  margin-left: 0.2vw;
  color: black;
  font-size: 1vw;
}
.title-bottom{
  height: 3vh;
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}
.card-tag {
  width: 2.5vw;
  display: flex;
  flex-direction: column;
  align-content: center;
  position: absolute;
  right:0;
  top:0.5vw;
}
.more {
  display: inline-block;
  height: 3vh;
  line-height: 3vh;
  margin-left: auto;
  color: #5eb2f7;
  cursor: pointer;
  white-space: nowrap;

}
.tag {
  width: 2.5vw;
  height: 1.2vw;
  margin-bottom: 0.4vw;
}
.h5-icon{
  background-image: url("http://data.xiyilab.com/web/main/static//app/标签H5.png.png");
  width: 2.5vw;
  height: 1.2vw;
  background-position: right;
  background-repeat: no-repeat;
  background-size: contain;
}

.windows-icon{
  background-image: url("http://data.xiyilab.com/web/main/static//app/标签Windows.png.png");
  width: 2.5vw;
  height: 1.2vw;
  background-position: right;
  background-repeat: no-repeat;
  background-size: contain;
}
.ios-icon{
  background-image: url("http://data.xiyilab.com/web/main/static//app/标签ios.png.png");
  width: 2.5vw;
  height: 1.2vw;
  background-position: right;
  background-repeat: no-repeat;
  background-size: contain;
}
.android-icon{
  background-image: url("http://data.xiyilab.com/web/main/static//app/标签Android.png.png");
  width: 2.5vw;
  height: 1.2vw;
  background-position: right;
  background-repeat: no-repeat;
  background-size: contain;
}
.vr-icon{
  background-image: url("http://data.xiyilab.com/web/main/static//app/标签VR.png");
  width: 2.5vw;
  height: 1.2vw;
  background-position: right;
  background-repeat: no-repeat;
  background-size: contain;
}


.phy-back{
  background-image: url("http://data.xiyilab.com/web/main/static//实验/物理.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.chem-back{
  background-image: url("http://data.xiyilab.com/web/main/static//实验/化学.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.bio-back{
  background-image: url("http://data.xiyilab.com/web/main/static//实验/生物.png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
</style>
